




































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  public showDialog: boolean = false;

  public openWeixin() {
    this.showDialog = true;
  }
}
